import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer-modern" id="contact">
      <div className="footer-container">
        <div className="footer-grid-modern">
          {/* Brand Section */}
          <div className="footer-brand">
            <a href="#top">
              <h2>Upgrace.in</h2>
            </a>
            <p className="footer-desc">
              Engineering the future with AI, Blockchain, and Scalable Web Solutions.
              Your partner in digital transformation.
            </p>
            <div className="social-links">
              <a href="https://linkedin.com/in/upgrace-in" target="_blank" rel="noreferrer" className="social-icon" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://x.com/upgrace_in" target="_blank" rel="noreferrer" className="social-icon" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.instagram.com/gpt_prince/" target="_blank" rel="noreferrer" className="social-icon" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="mailto:upgrace.in@gmail.com" className="social-icon" aria-label="Email">
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h3>Company</h3>
            <ul className="footer-links">
              <li><a href="#services" className="footer-link">Services</a></li>
              <li><a href="#work" className="footer-link">Our Work</a></li>
              <li><a href="#testimonials" className="footer-link">Success Stories</a></li>
              <li><a href="#contact" className="footer-link">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h3>Services</h3>
            <ul className="footer-links">
              <li><a href="#services" className="footer-link">AI Integration</a></li>
              <li><a href="#services" className="footer-link">Web Development</a></li>
              <li><a href="#services" className="footer-link">Blockchain dApps</a></li>
              <li><a href="#services" className="footer-link">Automation</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="copyright mx-auto">
            &copy; {currentYear} Upgrace. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
